import { useQuery } from "react-query";
import { useGlobalMessage } from "src/shared/context/globalMessage";
import { httpClient } from "src/shared/services/httpClient";

export default function useGetGlobalMessage() {
  const { infoMessage } = useGlobalMessage();

  const isError502Page = window.location.pathname === "/error502";

  return useQuery({
    queryFn: () => httpClient.get("/public/getGlobalMessage"),
    queryKey: ["get-global-message", infoMessage.date],
    retry: true,
    enabled: !isError502Page,
  });
}
